import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import dayjs from 'dayjs';

const TimePicker = ({ value, handleTimeSelect, setIsTime }) => {
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticTimePicker defaultValue={value ? dayjs(value) : dayjs()} onChange={handleTimeSelect}
                    slotProps={{
                        actionBar: {
                            actions: []
                        }
                    }}
                    sx={{
                        '& .MuiClockPointer-root': {
                            backgroundColor: '#4038ff !important',
                        },
                        '& .MuiClock-pin': {
                            backgroundColor: '#4038ff !important',
                        },
                        '& .MuiClockPointer-thumb': {
                            border: '16px solid #4038ff',
                            backgroundColor: '#4038ff !important'
                        },
                        '& .MuiPickersToolbar-root': {
                            backgroundColor: '#4038ff !important',
                        },
                        '& .MuiTypography-root': {
                            color: 'white !important',
                        },
                    }} />
                <div style={{ margin: 0 }} className="bg-white flex items-center justify-end p-2">
                    <button onClick={() => setIsTime(false)} className='px-[8px] py-[6px] text-[#4038ff] w-[70px]'>CANCEL</button>
                    <button onClick={() => { setIsTime(false); !value && handleTimeSelect(dayjs()) }} className='px-[8px] py-[6px] text-[#4038ff] w-[70px]'>OK</button>
                </div>
            </LocalizationProvider>
        </div>
    )
}

export default TimePicker